<template>
  <section class="enterprise-cta">
    <div class="container">
      <div class="cta-content">
        <h2>{{ $t('enterprise.ctaSubtitle') }}</h2>
        <p>让我们帮助您找到最适合的人才，加速项目进度，降低用人风险</p>
        <div class="cta-buttons">
          <button class="primary-button" @click="handleContactSales">
            <span>{{ $t('enterprise.consultBusiness') }}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="secondary-button" @click="handleScheduleDemo">
            <span>{{ $t('enterprise.bookDemo') }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EnterpriseCTA',
  methods: {
    handleContactSales() {
      alert('企业商务咨询 - 将显示联系表单或弹窗')
    },
    handleScheduleDemo() {
      alert('产品演示预约 - 将显示日历选择器')
    }
  }
}
</script>

<style scoped>
.enterprise-cta {
  padding: 4rem 2rem;
  background: linear-gradient(135deg, rgba(0, 102, 255, 0.15), rgba(138, 43, 226, 0.15));
  border-top: 1px solid rgba(0, 217, 255, 0.2);
  border-bottom: 1px solid rgba(0, 217, 255, 0.2);
}

.container {
  max-width: 900px;
  margin: 0 auto;
}

.cta-content {
  text-align: center;
}

.cta-content h2 {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cta-content p {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2rem;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.primary-button,
.secondary-button {
  padding: 14px 32px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.primary-button {
  background: linear-gradient(135deg, #0066FF, #8A2BE2);
  color: #FFFFFF;
  box-shadow: 0 4px 15px rgba(0, 102, 255, 0.3);
}

.primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 102, 255, 0.4);
}

.secondary-button {
  background: transparent;
  border: 2px solid rgba(0, 217, 255, 0.3);
  color: #FFFFFF;
}

.secondary-button:hover {
  background: rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.6);
}

@media (max-width: 768px) {
  .cta-content h2 {
    font-size: 1.6rem;
  }

  .enterprise-cta {
    padding: 2.5rem 1.5rem;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .primary-button,
  .secondary-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
